import React from 'react';
import { v4 as uuidv4 } from 'uuid'; // Importez la fonction v4 pour générer un UUID

/**
 * Génère un identifiant de dispositif alphanumérique de 20 caractères.
 */
function generateDeviceId() {
  // Générer un UUID
  const deviceId = uuidv4();
  
  // Filtrer pour conserver uniquement les caractères alphanumériques
  const alphanumericDeviceId = deviceId.replace(/[^a-zA-Z0-9]/g, '');
  
  // Retourner la partie du UUID qui correspond à la longueur souhaitée (par exemple, 20 caractères)
  return alphanumericDeviceId.substring(0, 20).toUpperCase();
}

export default generateDeviceId;